class TokenNotFoundError extends Error {
  constructor(message) {
    super(message);
    this.name = 'TokenNotFoundError';
    this.stack = new Error().stack;
  }
}

export default TokenNotFoundError;
